import { PageTemplate } from "@@/buyer-account/components/page-template";
import { ReceivingPoints } from "../../components/receiving-points";
import { InformerModal } from "../../components/informer-modal";
import sucessImg from '@@/buyer-account/images/success.svg';
import villageImg from '@@/buyer-account/images/village.svg';
import { fetchBuyerPointsFx } from "../../store/points.store";
import { useEffect } from "react";
import { deleteBuyerPoint } from "../../functions/delete-buyer-point.function";

export const PointsPage = () => {
    const navItems = [
        { label: 'предложения', to: '/', active: false },
        { label: 'пункты приема', to: '/buyer-points', active: true },
    ];
    useEffect(() => {
        fetchBuyerPointsFx()

    }, []);
    return (
        <PageTemplate navItems={navItems}>
            <ReceivingPoints/>
            {/* <InformerModal imageScaled={true} content={
                <p>
                    <span>Ваша заявка одобрена!</span><br/>
                    Теперь вы можете принимать участие в сделках!
                </p>
            } img={sucessImg}/> */}
            {/* <InformerModal content={'Для начала работы в сервисе вы должны указать адреса пунктов приема зерна'} img={villageImg}/> */}
        </PageTemplate>
    )
}